export default __webpack_public_path__ + "static/media/godoCoin.811db12f.svg";